/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Mixdown_CompleteInputs */

const en_audio_description_export_status_mixdown_complete = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio mixdown complete!`)
};

const fr_audio_description_export_status_mixdown_complete = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixdown audio terminé !`)
};

const de_audio_description_export_status_mixdown_complete = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiomixdown abgeschlossen!`)
};

const it_audio_description_export_status_mixdown_complete = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixaggio audio completato!`)
};

const ru_audio_description_export_status_mixdown_complete = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сведение звука завершено!`)
};

const es_audio_description_export_status_mixdown_complete = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Mezcla de audio completada!`)
};

const zh_cn2_audio_description_export_status_mixdown_complete = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频混音完成！`)
};

const ja_audio_description_export_status_mixdown_complete = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオミックスダウンが完了しました！`)
};

const hi_audio_description_export_status_mixdown_complete = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो मिक्सडाउन पूरा हो गया!`)
};

const pt_pt2_audio_description_export_status_mixdown_complete = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixagem de áudio concluída!`)
};

/**
* | output |
* | --- |
* | "Audio mixdown complete!" |
*
* @param {Audio_Description_Export_Status_Mixdown_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_mixdown_complete = /** @type {((inputs?: Audio_Description_Export_Status_Mixdown_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Mixdown_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_mixdown_complete(inputs)
	if (locale === "de") return de_audio_description_export_status_mixdown_complete(inputs)
	if (locale === "it") return it_audio_description_export_status_mixdown_complete(inputs)
	if (locale === "ru") return ru_audio_description_export_status_mixdown_complete(inputs)
	if (locale === "es") return es_audio_description_export_status_mixdown_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_mixdown_complete(inputs)
	if (locale === "ja") return ja_audio_description_export_status_mixdown_complete(inputs)
	if (locale === "hi") return hi_audio_description_export_status_mixdown_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_mixdown_complete(inputs)
	return en_audio_description_export_status_mixdown_complete(inputs)
});